export default __webpack_public_path__ + "static/royal_grimoire-dbd4d60efa59701f72c578a32a76ccc7.png";